import {
  axiosApiInstance,
  axiosStorageInstance,
  axiosPrinterInstance,
} from "../axios";

export async function makePostApiCall(
  endPoint,
  payload,
  contentType = "application/json"
) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType,
    },
  };

  const user_id = localStorage.getItem("id") * 1;
  const user_name = localStorage.getItem("name");

  const newPayload = {
    ...payload,
    user_id: user_id,
    user_name: user_name,
  };

  return axiosApiInstance
    .post(endPoint, newPayload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
    if (!err){
        return  {data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: 500,
        },
      }
    }

    if (!err.response){
        return  {data: {
          title: "Error",
          message: "We could not complete the action.",
          errorStatus: 500,
        },
      }
    }

      const emptyData = {
        data: {
          title: "Error",
          message: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

export async function makePutApiCall(endPoint, payload, contentType) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType ? contentType : "application/json",
    },
  };

  const user_id = localStorage.getItem("id") * 1;
  const user_name = localStorage.getItem("name");

  const newPayload = {
    ...payload,
    user_id: user_id,
    user_name: user_name,
  };

  return axiosApiInstance
    .put(endPoint, newPayload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const errorStatus = err.response?.status;
      const emptyData = {
        data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          message: "We could not complete the action.",
          errorStatus,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData.data,
          errorStatus,
        };
      }
    });
}

export async function makeDeleteApiCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosApiInstance
    .delete(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const emptyData = {
        data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: err.response?.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      }

      return {
        success: false,
        data: emptyData,
        errorStatus: err.response?.status,
      };
    });
}

export async function makeGetApiCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosApiInstance
    .get(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const errorStatus = err.response?.status;
      const fallbackData = {
        title: "Error",
        subtitle: "We could not complete the action.",
        message: "We could not complete the action.",
        errorStatus,
      };

      return {
        success: false,
        data: err.response?.data || fallbackData,
        errorStatus,
      };
    });
}

export async function downloadAuthenticatedFile(
  endPoint,
  fileName = "report.pdf"
) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    responseType: "blob",
  };

  return axiosApiInstance
    .get(endPoint, config)
    .then((response) => {
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    })
    .catch((err) => ({
      success: false,
      data: err?.response?.data || {
        message: "We could not download the report.",
      },
      errorStatus: err?.response?.status || 500,
    }));
}

export async function makeGetCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosStorageInstance
    .get(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const emptyData = {
        data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

export async function makePostApiCallToPrinter(payload) {
  const config = {};

  const user_id = localStorage.getItem("id") * 1;
  const user_name = localStorage.getItem("name");

  const newPayload = {
    ...payload,
    user_id: user_id,
    user_name: user_name,
  };

  return axiosPrinterInstance
    .post("/print-label", newPayload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const emptyData = {
        data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

// POST request expecting a binary/blob response (e.g. file download)
export async function makePostApiCallBlob(endPoint, payload) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": "application/json",
    },
    responseType: "blob",
  };

  const user_id = localStorage.getItem("id") * 1;
  const user_name = localStorage.getItem("name");

  const newPayload = {
    ...payload,
    user_id: user_id,
    user_name: user_name,
  };

  return axiosApiInstance
    .post(endPoint, newPayload, config)
    .then((response) => {
      // response.data is a blob
      return {
        success: true,
        data: response.data,
        headers: response.headers,
      };
    })
    .catch((err) => {
      // Try to extract status when available
      const status =
        err && err.response && err.response.status ? err.response.status : null;

      // We don't attempt to parse blob error bodies here; caller can handle generic failures.
      return {
        success: false,
        data: {
          title: "Error",
          subtitle: "We could not complete the download.",
        },
        errorStatus: status,
      };
    });
}
